module.exports = __webpack_public_path__ + "nc_static/media/dd_my_contract.1b553ca2.svg";